import { AkaHealthConfig } from "Store/akaHealthConfig/akaHealthConfigInterfaces";
import { isDefined } from "Utils/functions";

export const canCustomerPurchaseMemberInsurance = (
  akaHealthConfig: AkaHealthConfig | null,
): boolean => {
  return isDefined(akaHealthConfig)
    ? akaHealthConfig.canPurchaseMemberInsurance
    : true;
};
